export default "{\n    \"emptyPlaceholder\": \"Sélectionner un type\",\n    \"searchPlaceholder\": \"Rechercher des types\"\n}\n"